/* =====================================================================
 * consent-offset.js — publish how much of the screen bottom the consent
 * banner covers, as --consent-offset on <html>.
 *
 * TrueVault Polaris docks its consent banner at the bottom of the screen
 * until the visitor answers it. The mobile sticky Add to Cart bars
 * (.v6-sticky-buy on product pages, .persona-mobile-atc on persona pages)
 * read --consent-offset as their `bottom` so they sit just above the banner
 * instead of under it. 0px when the banner is hidden or gone.
 * The banner itself is never touched.
 *
 * Measuring logic is the same as consentOffset() in native-cart.js (which
 * keeps its own --ncart-consent-offset for the cart drawer).
 * ===================================================================== */
(function () {
  'use strict';

  var POLARIS_HOST_ID = 'polaris-css-lockdown-container';
  var docEl = document.documentElement;
  var timer = 0;

  function consentOffset() {
    var host = document.getElementById(POLARIS_HOST_ID);
    var shadow = host && host.shadowRoot;
    var widgets = shadow && shadow.getElementById('polaris-consent-widgets');
    if (!widgets) return 0;
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    var top = vh;
    var els = widgets.querySelectorAll('*');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.closest('[class*="polaris-preferences-fab"]')) continue;
      var cs = window.getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden') continue;
      var r = el.getBoundingClientRect();
      if (!r.width || !r.height) continue;
      if (r.right <= 0 || r.left >= vw || r.bottom <= 0 || r.top >= vh) continue;
      if (r.top < top) top = r.top;
    }
    return Math.max(0, Math.round(vh - top));
  }

  function update() {
    timer = 0;
    var px = consentOffset() + 'px';
    if (docEl.style.getPropertyValue('--consent-offset') !== px) {
      docEl.style.setProperty('--consent-offset', px);
    }
  }
  function schedule() {
    if (!timer) timer = setTimeout(update, 50);
  }

  docEl.style.setProperty('--consent-offset', '0px');

  // Polaris injects its host late; retry attaching for up to 15 s.
  var started = Date.now();
  (function attach() {
    var host = document.getElementById(POLARIS_HOST_ID);
    if (host && host.shadowRoot) {
      new MutationObserver(schedule).observe(host.shadowRoot, {
        childList: true, subtree: true, attributes: true
      });
      schedule();
      return;
    }
    if (Date.now() - started < 15000) setTimeout(attach, 250);
  })();

  window.addEventListener('resize', schedule);
  window.addEventListener('orientationchange', schedule);
})();
